import useFetch from "../api/useFetch";
import usePost from '../api/usePost';
import Loading from "./Loading";
import ShipmentLine from "./ShipmentLine"
import '../css/products.css'

const Shipments = () => {
      const { result: shipments, isLoading: shipmentsLoading, error: shipmentsError } = useFetch('/get_martelle_shipments',[]);
      const { postData } = usePost();

      const createUspsPickupRequest = async () => {
        const numPackages = prompt('Enter number of packages:');
        if (numPackages === null) return; // User cancelled

        const totalWeight = prompt('Enter total weight (in pounds):');
        if (totalWeight === null) return; // User cancelled

        // Validate inputs
        if (isNaN(numPackages) || isNaN(totalWeight) || numPackages <= 0 || totalWeight <= 0) {
          alert('Please enter valid numbers greater than 0');
          return;
        }

        try {
          const response = await postData('/create_usps_pickup_request', {
            num_packages: parseInt(numPackages),
            total_weight: parseFloat(totalWeight)
          });
          if (response) {
            // You might want to add a notification here if you have a notification system
            console.log('USPS Pickup Request created successfully');
          }
        } catch (error) {
          console.error('Error creating USPS Pickup Request:', error);
        }
      };

  return (
    
    <>
  <div className="products">
  <div div className="title">
          SHIPMENTS
        </div>
   <div className="orders-select" style={{ justifyContent: 'center' }}>
     <div className='group-selected-button' onClick={createUspsPickupRequest}>USPS Pickup Request</div>
   </div>
   <div className="table">
    <div className="table-header">
      <div className="date">Creation Date</div>
      <div className="small">Tracking Number</div>
      <div className="large">Carrier</div>
      <div className="small">Status</div>
      <div className="small">Tracking</div>
      <div className="action">Orders</div>
    </div>
    <div className="table-body">
            {shipmentsLoading && <div className='table-placeholder'><Loading /></div>}
            {shipmentsError && <div>{shipmentsError}</div>}
            {!shipmentsLoading &&  shipments && shipments.items.length > 0 && shipments.items.map((shipment) => <ShipmentLine carrier={shipment.carrier} shipment_id={shipment.id} tracking_number={shipment.tracking_number} shipment_date={shipment.creation_date} shipment_status={shipment.status}  tracking_url={shipment.tracking_link}/>)}
          </div>
    </div>
   </div>
   </>
  )
}

export default Shipments